import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { convertDate } from '../../../utils/utils';
import { nl2br } from '../../../utils/nl2br';
import * as assessmentsActions from '../../../redux/actions/assessmentsActions';

import LoadingButton from '../../common/LoadingButton';

class ReviewHead extends Component {
  constructor(props) {
    super(props);
    this.state = { isRequestingPDF: false };
  }

  download = () => {
    const { dispatchAssessmentsActions, assessmentIds } = this.props;
    dispatchAssessmentsActions.downloadComparison(assessmentIds, this.onSuccess);
    this.setState({ isRequestingPDF: true });
  }

  onSuccess = () => {
    this.setState({ isRequestingPDF: false });
  }

  // onFail
  // Alert that something went wrong with the download

  render() {
    const { isRequestingPDF } = this.state;
    const { assessments, toggleFlaggedQuestions, colClass, colorClass, section, users, showFlaggedQuestionsOnly } = this.props;

    return (
      <Fragment>
        <div className="row">
          <div className="review-detail__button-wrapper">
            <LoadingButton
              text="Download"
              onClick={this.download}
              loading={isRequestingPDF}
              largeButton={false}
            />
          </div>
        </div>
        <div className="row">
          {assessments.map(assessment => (
            <div className={colClass} key={assessment.id}>
              <div className={'review-detail__heading ' + colorClass}>
                {section.title}
              </div>
              <div className="review-detail__label">
                Completed:
                {' '}
                {convertDate(assessment.dateCompleted)}
              </div>
              <div className="review-detail__name">
                {users[assessment.lastEditedBy]
                  && users[assessment.lastEditedBy].firstName + ' ' + users[assessment.lastEditedBy].lastName}
              </div>
              {section.hasArea && (
                <div>
                  <div className="review-detail__label review-detail__label--inline">
                    {'Area: '}
                  </div>
                  <div className="review-detail__name review-detail__name--inline">
                    {assessment.area || <span className="unanswered">N/A</span>}
                  </div>
                </div>
              )}
              <div>
                <div className="review-detail__label review-detail__label--inline">
                  {'Department: '}
                </div>
                <div className="review-detail__name review-detail__name--inline">
                  {assessment.department || <span className="unanswered">N/A</span>}
                </div>
              </div>
              <div>
                <div className="review-detail__label review-detail__label--inline">
                  {'Facilitator(s): '}
                </div>
                <div className="review-detail__name review-detail__name--inline">
                  {assessment.facilitators.length ? (
                    assessment.facilitators.map((facilitator, i) => (
                      <span key={i}>
                        {facilitator.name}
                      </span>
                    )).reduce((accu, elem) => (accu === null ? [elem] : [...accu, ', ', elem]), null)
                  ) : (
                    <span className="unanswered">N/A</span>
                  )}
                </div>
              </div>
              <div>
                <div className="review-detail__label review-detail__label--inline">
                  {'Participant(s): '}
                </div>
                <div className="review-detail__name review-detail__name--inline">
                  {assessment.participants.length ? (
                    assessment.participants.map((participant, i) => (
                      <span key={i}>
                        {participant.name}
                      </span>
                    )).reduce((accu, elem) => (accu === null ? [elem] : [...accu, ', ', elem]), null)
                  ) : (
                    <span className="unanswered">
                      N/A
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row">
          <div className="review-detail__full-width-col review-detail__subheading review-detail__subheading--margin-top">
            Assessor comments about this module
          </div>
        </div>
        <div className="row">
          {assessments.map(assessment => (
            <div className={colClass} key={assessment.id}>
              <div className="review-detail__date">
                {convertDate(assessment.dateCompleted)}
              </div>
              <p className="review-detail__comments">
                {nl2br(assessment.notes) || <span className="unanswered">N/A</span>}
              </p>
            </div>
          ))}
        </div>
        <div className="row">
          <div className="review-detail__full-width-col review-detail__subheading">
            <span>
              Flagged questions in this module
            </span>
            <button
              type="button"
              className="review-detail__toggle-flagged-button flat-link-from-button"
              onClick={toggleFlaggedQuestions}
            >
              {showFlaggedQuestionsOnly
                ? 'See all questions'
                : 'See only flagged'}
            </button>
          </div>
        </div>
        <div className="row">
          {assessments.map(assessment => (
            <div className={`review-detail__digit ${colClass}`} key={assessment.id}>
              <div className="review-detail__date">
                {convertDate(assessment.dateCompleted)}
              </div>
              {assessment.flaggedQuestions
                ? assessment.flaggedQuestions
                : <span className="unanswered">N/A</span>
              }
            </div>
          ))}
          <hr className="review-detail__hr" />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = undefined;

function mapDispatchToProps(dispatch) {
  return { dispatchAssessmentsActions: bindActionCreators(assessmentsActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewHead);



// WEBPACK FOOTER //
// ./src/components/features/review/ReviewHead.js